import React from "react";
import "../styles/Social.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faTwitter,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export function Social() {
  return (
    <>
      <div className="icon-container">
        <a href="mailto:cladams0203@gmail.com">
          <FontAwesomeIcon icon={faEnvelope} className="icons" />
        </a>
        <a
          href="https://github.com/cladams0203"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faGithub} className="icons" />
        </a>
        <a
          href="https://www.linkedin.com/in/cladams0203/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faLinkedin} className="icons" />
        </a>
        <a
          href="https://twitter.com/ChrisAd55717923"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faTwitter} className="icons" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCLPb5sQr38dWiYcfMsLdSeg"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faYoutube} className="icons" />
        </a>
        <div className="line-decoration"></div>
      </div>
    </>
  );
}
